export const DAY_TS = 24 * 60 * 60 * 1000

export const DAY_NAMES = ['sun_short', 'mon_short', 'tue_short', 'wed_short', 'thu_short', 'fri_short', 'sat_short']
export const MONTH_NAMES = [
  'jan_short',
  'feb_short',
  'mar_short',
  'apr_short',
  'may_short',
  'jun_short',
  'jul_short',
  'aug_short',
  'sep_short',
  'oct_short',
  'nov_short',
  'dec_short'
]

export const formatDate = (date = {}) => {
  const year = date.getFullYear()
  const month = pad(date.getMonth() + 1)
  const day = pad(date.getDate())

  return `${year}-${month}-${day}`
}

const pad = num => (num < 10 ? `0${num}` : num)
